import { UserSubscription } from '@creditsights/api-ui-web';
import { ROUTES } from '../../Base.constants';
import { ContentTypeFilter, FeedType } from '../../models';

export const getFeedType = (pathname: string): FeedType => {
  switch (pathname) {
    case ROUTES.specialSituations:
      return FeedType.SpecialSituations;
    case ROUTES.feed:
      return FeedType.My;
    case ROUTES.globalFeed:
    default:
      return FeedType.Global;
  }
};

export const getInitialActiveTab = (subscription: UserSubscription): ContentTypeFilter => {
  switch (subscription) {
    case UserSubscription.CS:
      return ContentTypeFilter.RESEARCH;
    case UserSubscription.CR:
      return ContentTypeFilter.COVENANTS;
    case UserSubscription.LFI:
      return ContentTypeFilter.NEWS;
    default:
      return ContentTypeFilter.ALL;
  }
};
